import { render, staticRenderFns } from "./BasicEditerVertical.vue?vue&type=template&id=2d1ca1ab&scoped=true"
import script from "./BasicEditerVertical.vue?vue&type=script&lang=js"
export * from "./BasicEditerVertical.vue?vue&type=script&lang=js"
import style0 from "./BasicEditerVertical.vue?vue&type=style&index=0&id=2d1ca1ab&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d1ca1ab",
  null
  
)

export default component.exports